import React from 'react';
import { Form, Button, Modal, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faFile } from '@fortawesome/free-solid-svg-icons'; // icons for expand/collapse, and leaf

import {
		textFieldIconData, integerFieldIconData, dropdownFieldIconData, 
		decimalFieldIconData, dateFieldIconData, dateTimeFieldIconData, doubleFieldIconData, booleanFieldIconData
} from './constants';



interface DataModelTreeProps {
  show: boolean;
  handleClose: () => void;
  handleSave: (newSelectedAdd: string[], newSelectedRemove: string[]) => void;
  dataModelData: any;
  selectedIds: string[];
}

interface DataModelTreeState {
  selected: Set<string>;
  expandedNodes: Set<string>;
  dataModelData: any;
  newSelectedAdd: Set<string>;
  newSelectedRemove: Set<string>;
  //dataModelTreeData: any;
}

class DataModelTreeModal extends React.Component<DataModelTreeProps, DataModelTreeState> {
  constructor(props: DataModelTreeProps) {
    super(props);
      
    
    this.state = {
      selected: new Set<string>(this.props.selectedIds),
      expandedNodes: new Set<string>(['100']),
      dataModelData: [this.props.dataModelData],
      newSelectedAdd: new Set<string>([]),
      newSelectedRemove: new Set<string>([]),
    };
  }
  
  textFieldIcon: JSX.Element = ( <a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={textFieldIconData} alt="" style={{height: '11px'}}></img>
  </a>);
  integerFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={integerFieldIconData} alt="" style={{height: '8px'}}></img>
  </a>);
  dropdownFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dropdownFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  decimalFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={decimalFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  dateFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dateFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  dateTimeFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={dateTimeFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  doubleFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={doubleFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);
  booleanFieldIcon: JSX.Element = (<a style={{marginTop:'0px', marginRight:'10px'}}>
      <img src={booleanFieldIconData} alt="" style={{height: '13px'}}></img>
  </a>);

  toggleSelect = (node:any) => {
    const id = node.id||node.FLD_ID;
    this.setState((prevState) => {
      const newSelected = new Set(prevState.selected);
      const newSelectedAdd = new Set(prevState.newSelectedAdd);
      const newSelectedRemove = new Set(prevState.newSelectedRemove);
      if (node.eClass === 'FieldGroup'){ //table selected/unslected. retrieve all fields
        
      }
      if (newSelected.has(id)) {
        newSelected.delete(id);
        
        newSelectedRemove.add(id);
        if (newSelectedAdd.has(id)) {
           newSelectedAdd.delete(id);
        }
      } else {
        if (node.eClass === 'Field' && !newSelected.has(node.FLD_ID.split('-')[0])){
          const pid = node.FLD_ID.split('-')[0];
          newSelected.add(pid);
          newSelectedAdd.add(pid);
          if (newSelectedRemove.has(pid)) {
             newSelectedRemove.delete(pid);
          }
        }
        
        newSelected.add(id);
        
        newSelectedAdd.add(id);
        if (newSelectedRemove.has(id)) {
           newSelectedRemove.delete(id);
        }
        
      }
      return { selected: newSelected, newSelectedAdd, newSelectedRemove };
    });
  };

  toggleExpand = (id: string) => {
    this.setState((prevState) => {
      const newExpandedNodes = new Set(prevState.expandedNodes);
      if (newExpandedNodes.has(id)) {
        newExpandedNodes.delete(id);
      } else {
        newExpandedNodes.add(id);
      }
      return { expandedNodes: newExpandedNodes };
    });
  };
  
  handleUpdate = () =>{
    this.props.handleSave(Array.from(this.state.newSelectedAdd), Array.from(this.state.newSelectedRemove));
    
  }

  renderNode = (node: any) => {
    const id = node.id||node.FLD_ID;
    const label = node.label||node.COLUMN_DISPLAY_NAME;
    const isChecked = this.state.selected.has(id);
    const isExpanded = this.state.expandedNodes.has(id);
    const hasfield = node.field && node.field.length > 0;
    const labelChk =  <div style={{ display: 'flex',}}>
         <div style={{width:'30px'}} className="d-flex justify-content-center">   
            {(node && !node.DATA_TYP) && <FontAwesomeIcon icon={faFile} style={{ marginRight: '15px' }} />}
            {(node && node.DATA_TYP === "TextField") && this.textFieldIcon }
            {(node && node.DATA_TYP === "IntegerField") && this.integerFieldIcon }
            {(node && node.DATA_TYP === "LookupField") && this.dropdownFieldIcon }
            {(node && node.DATA_TYP === "DateField") && this.dateFieldIcon }
            {(node && node.DATA_TYP === "DateTimeField") && this.dateTimeFieldIcon }
            {(node && node.DATA_TYP === "DecimalField") && this.decimalFieldIcon }
        </div>
        <span>{label}</span>
    </div>

    return (
      <div key={id} style={{ paddingLeft: '20px', marginBottom: '5px' }}>
        <div style={{ display: 'flex',  }}>
          <div style={{}} className="d-flex justify-content-center">
          {hasfield ? (
            <Button
              variant="link"
              size="sm"
              onClick={() => this.toggleExpand(node.id)}
              style={{ marginRight: '5px', marginTop: '-8px' }}
            >
              <FontAwesomeIcon icon={isExpanded ? faMinus : faPlus} />
            </Button>
          ) : (
            <>
              
            </>
          )}
          </div>
          <Form.Check
            type="checkbox"
            label={labelChk}
            checked={isChecked}
            style={{fontSize:"12px"}}
            onChange={() => this.toggleSelect(node)}
          />
        </div>
        {isExpanded && node.field && (
          <div style={{ paddingLeft: '15px' }}>
            {node.field.map(this.renderNode)}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { show, handleClose } = this.props;
    
    return(
      <Modal show={show} onHide={handleClose} dialogClassName="field-edit-modal">
		
        <Modal.Header closeButton>
          <Modal.Title>Data Model</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: '420px', overflowY: 'auto' }}>{this.state.dataModelData.map(this.renderNode)}</div>;
        </Modal.Body>
        <Modal.Footer>
          <Row className="mt-3">
              <Col>
                  <Button variant="primary" type="submit"  onClick={this.handleUpdate} >
                    Update
                  </Button>
              </Col>
          </Row>
        </Modal.Footer>
      </Modal>
          
    )
  }
}

export default DataModelTreeModal;
